
export class DvirFormReviewingSignaturesOption {
    public static readonly ALWAYS_REQUIRED = new DvirFormReviewingSignaturesOption('Always', 'All forms must be signed by a mechanic or supervisor', 'ALWAYS_REQUIRED');
    public static readonly REQUIRED_ON_ISSUE = new DvirFormReviewingSignaturesOption('On Failure', 'Any defect must be co-signed by a mechanic or supervisor', 'REQUIRED_ON_ISSUE');
    public static readonly NEVER_REQUIRED = new DvirFormReviewingSignaturesOption('Never required', '', 'NEVER_REQUIRED');

    public static readonly options = [
        DvirFormReviewingSignaturesOption.ALWAYS_REQUIRED,
        DvirFormReviewingSignaturesOption.REQUIRED_ON_ISSUE,
        DvirFormReviewingSignaturesOption.NEVER_REQUIRED
    ];

    public static readonly signatureOptions = [
        DvirFormReviewingSignaturesOption.ALWAYS_REQUIRED,
        DvirFormReviewingSignaturesOption.REQUIRED_ON_ISSUE,
    ];

    static readonly label = 'Reviewing Signatures';
    static readonly default = DvirFormReviewingSignaturesOption.ALWAYS_REQUIRED;
    static readonly optionCode = 'REVIEWING_SIGNATURES';

    label: string;
    description: string;
    code: string;

    constructor(label: string, description: string, code: string) {
        this.label = label;
        this.description = description;
        this.code = code;
    }

    static fromCode(code: string) {
        const found = DvirFormReviewingSignaturesOption.options.find(value => value.code === code);
        if (found == null) { throw new Error(`error parsing MifFormReviewingSignaturesOption, code = ${code}`); }
        return found;
    }
}
